import { FETCH_ORG_LIST} from "./type";
import * as actionFunction from  './common';
function userList() {
    // console.log("posts", post.email)
    var commonStateData = actionFunction.commonData()
    // console.log("data", commonStateData);
    return (dispatch) => {
        fetch(commonStateData.apiUrl + '/HrmanagementRest/GetOrganization/userAuthKey/' + commonStateData.userAuthKey +'/userId/' + commonStateData.userId, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(commonStateData),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {

                findresponse = actionFunction.decrypt(findresponse, 1);
                // console.log("new respose from actions", findresponse)
                dispatch({
                    type: FETCH_ORG_LIST,
                    organisation: findresponse.users_emp,
                    users_md: findresponse.users_md,
                    md_attachment_url:findresponse.users_md.md_attachment_url,
                    md_name_cond:findresponse.users_md.md_name.charAt(0).toUpperCase(),
                })

            })
    }
}

export {userList };


// WEBPACK FOOTER //
// ./src/actions/organizationChart.js